const Footer = () => {
  return (
    <footer className="mx-auto w-full max-w-2xl px-5 pb-10">
      <div className="flex flex-wrap justify-between gap-x-6 gap-y-1 border-t border-zinc-200 pt-6 text-sm text-zinc-500 dark:border-zinc-800">
        <p className="text-sm">MB „Pirmas kodas“, įmonės kodas 306129624</p>
        <p className="flex gap-4 text-sm">
          <a href="tel:+37064139571">+370 641 39571</a>
          <a href="mailto:info@pirmaskodas.lt">info@pirmaskodas.lt</a>
        </p>
      </div>
    </footer>
  )
}

export default Footer
